import React from 'react';

/**
 * Visualizador — moldura para ler um documento dentro da tela: barra com título e ações,
 * e um fundo rolável onde fica a página. O conteúdo (children) é o documento.
 */
export default function Visualizador({ titulo, acoes, children }) {
  return (
    <section className="sj-visualizador" aria-label={titulo}>
      <header className="sj-visualizador__barra">
        <h2 className="titulo-cartao">{titulo}</h2>
        {acoes}
      </header>
      {/* Rola por dentro: precisa receber o foco para rolar pelo teclado. */}
      <div className="sj-visualizador__fundo" tabIndex={0}>{children}</div>
    </section>
  );
}
